import React, { useState, useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import "../Styles/SecuritySettings.css";
import { ThemeContext } from "../../../../../context/ThemeContext";

const SecuritySelector = () => {
    const [isSubscribed, setIsSubscribed] = useState(true);
    const [acceptedTerms, setAcceptedTerms] = useState(true);
    const [dataprivacyfromapp, setdataprivacyfromapp] = useState(false);
    const [datasharefromadvt, setdatashare] = useState(false);
    const [datasharefromtrackers, setdatasharetrackers] = useState(false);
    const [trackbrowsinghistory, settrackbrowsinghistory] = useState(false);
    const [accountvisibility, setaccountvisibility] = useState(false);
    const [activityvisibility, setactivityvisibility] = useState(false);
    const [pastpostvisibility, setpastpostvisibility] = useState(false);
    const [profilelinking, setprofilelinking] = useState(false);
    const [datadownload, setdatadownload] = useState(false);
    const [personaldatadownload, setpersonaldatadownload] = useState(false);
    const [deletionstrategy, setdeletionstrategy] = useState(false);
    const [profiledeletionstrategy, setprofiledeletionstrategy] = useState(false);
    const [encryptmessages, setencryptmessages] = useState(false);
    const [encryptchathistory, setencryptchathistory] = useState(false);
    const [autodeletemessage, setautodeletemessage] = useState(false);
    const [allowfeedtollmmodel, setallowfeedtollmmodel] = useState(false);
    const [errorMessage, setErrorMessage] = useState(""); // Added error handling
    const [selectedCheckbox, setSelectedCheckbox] = useState(null);
    const { theme } = useContext(ThemeContext);

    const handleSubmit = async (event) => {
      event.preventDefault();
  
      if (!acceptedTerms) {
        setErrorMessage('You must accept the Terms and Conditions to continue.');
        return;
      }
    
      const userData = {
        dataprivacyfromapp, 
        datasharefromadvt, 
        datasharefromtrackers, 
        trackbrowsinghistory, 
        accountvisibility,
        activityvisibility,
        pastpostvisibility, 
        profilelinking,
        datadownload,
        personaldatadownload,
        deletionstrategy,
        profiledeletionstrategy,
        encryptmessages,
        encryptchathistory,
        autodeletemessage,
        allowfeedtollmmodel,
      };
  
      try {
        const response = await fetch("/api/v1/user/account/config/add", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(userData), 
        });
  
        const result = await response.json();
        if (response.ok) {
          alert("Privacy Settings applied successfully!");
        } else {
          alert("Privacy Settings failed: " + result.message);
        }
      } catch (error) {
        setErrorMessage(error.message || 'Privacy Settings failed.');
      }
  
      setErrorMessage('');
    };

    useEffect(() => {
      // Dynamically import the correct theme CSS
      import(`../Styles/themes/${theme}/themes.css`)
      .then(() => {
        console.log(`Loaded ${theme} styles for UserProfile`);
      })
      .catch(() => {
        console.error(`Theme CSS not found for ${theme}`);
      });
    }, [theme]);

  return (
    <div className="st-privacy-settings-container" overflow-y= "scroll">
      {/* Company Logo */}
      <div style={{marginBottom: 20}}>      
        <p className="st-text" >
        Oowlet has been committed for securing users personal data. We don't collect and autherize anyone to collect any unwarrented data specific to 
        any user in any means. Even We have taken all necessary actions to secure the limited data that we collect from user. Most of the data being 
        used for our analytics purpose specific to recommendation engines for user and content suggestion. If you find any discrepency and 
        any misuse of data from our behalf, you can write to us on .. We will take the necessary action, as we feel personal data is the 
        intellectual property of each user. We ensure the secrecy and safety of users personal data.     
      </p>
      </div>
      
      {isSubscribed && (
      <div>
      <input type="checkbox"/>
      <label className= "st-text">
          Base Policies. 
      </label>

      <input type="checkbox"/>
      <label className= "st-text">
          Subscribed Policies.  
      </label>
      </div>
      )}

      <h3 className= "st-text-label" style={{color: "white"}}>1. Data sharing </h3>
      <div>
        <label>
        <input type="checkbox"
          checked={dataprivacyfromapp}
          onChange={() => setdataprivacyfromapp(!dataprivacyfromapp)}
          fontSize = "16px"
        />
          <span style={{color: "white", marginLeft: 10}}>
          Share with connected apps.
          </span> 
        </label>
        {dataprivacyfromapp && (
          <div>
            <label>
            <input 
              checked={dataprivacyfromapp === "Enable"}
              onChange={() => setdataprivacyfromapp("Enable")}         
              type="checkbox" style={{marginLeft: 30}}
            /> 
            <span style={{color: "white", marginLeft: 10}}>
            Enable
            </span>
            </label>
            <br />
            <label>
            <input 
              checked={dataprivacyfromapp === "Disable"}
              onChange={() => setdataprivacyfromapp("Disable")}
              type="checkbox" style={{marginLeft: 30}}
            />
              <span style={{color: "white", marginLeft: 10}}>       
              Disable
              </span>
            </label>
            <br />
          </div>
        )}
      </div>
      
      <div>
        <label>
        <input type="checkbox"
          checked={datasharefromadvt}
          onChange={() => setdatashare(!datasharefromadvt)}
        />
        <span style={{color: "white", marginLeft: 10}}>
            Data sharing with advertisers
          </span>
        </label>
        {datasharefromadvt && (
          <div>
              <label> 
              <input type="checkbox" 
              checked={datasharefromadvt === "Enable"}
              onChange={() => setdatashare("Enable")}
              style={{marginLeft: 30}} 
              />
              <span style={{color: "white", marginLeft: 10}}>
                Enable
              </span>
              </label>
              <br />
              <label> 
              <input type="checkbox"
                checked={datasharefromadvt === "Disable"}
                onChange={() => setdatashare("Disable")} 
                style={{marginLeft: 30}}/>
                <span style={{color: "white", marginLeft: 10}}>
                Disable
                </span>
            </label>
            <br />
          </div>
      )}
      </div>
      <div>
      <label>
      <input type="checkbox" 
        checked={datasharefromtrackers}
        onChange={() => setdatasharetrackers(!datasharefromtrackers)}
        fontFamily = "Poppins"
        fontSize = "15px"
      />
        <span style={{color: "white", marginLeft: 10}}>
          Trackers & analytics scripts.
        </span> 
      </label>
      {datasharefromtrackers && (
        <div>
          <label> 
          <input 
            checked={datasharefromtrackers === "Enable"}
            onChange={() => setdatasharetrackers("Enable")} 
            type="checkbox" 
            style={{marginLeft: 30}}/>
          <span style={{color: "white", marginLeft: 10}}>
           Enable
          </span>
          </label>
          <br />
          <label>
          <input 
                checked={datasharefromtrackers === "Disable"}
                onChange={() => setdatasharetrackers("Disable")} 
                style={{marginLeft: 30}}
                type="checkbox"/>
          <span style={{color: "white", marginLeft: 10}}> 
           Disable
           </span>
         </label>
         <br />
         </div>
      )}
      <div>
        <label>
        <input 
          checked={trackbrowsinghistory}
          onChange={() => settrackbrowsinghistory(!trackbrowsinghistory)}
          fontSize = "15px"
          type="checkbox"
        />
        <span style={{color: "white", marginLeft: 10}}>
          Privacy of your Browsing History.
        </span>    
        </label>

        {trackbrowsinghistory && (
        <div>
          <label> 
          <input 
            checked={trackbrowsinghistory === "Enable"}
            onChange={() => settrackbrowsinghistory("Enable")} 
            type="checkbox" 
            style={{marginLeft: 30 }}/>
            <span style={{color: "white", marginLeft: 10}}>
           Enable
           </span>
          </label>
          <br />
          <label>
          <input 
                checked={trackbrowsinghistory === "Disable"}
                onChange={() => settrackbrowsinghistory("Disable")} 
                style={{marginLeft: 30}}
                type="checkbox"/>
          <span style={{color: "white", marginLeft: 10}}> 
           Disable
           </span>
         </label>
         <br />
         </div>
      )}
      </div>
      </div>

      {isSubscribed && (
      <div>
      <h3 className= "st-text-label" style={{color: "white"}}>2. Content & Activity Visibility </h3>
      <div>
      <label>
      <input 
        type="checkbox"
        checked={accountvisibility}
        onChange={() => setaccountvisibility(!accountvisibility)}
      />
      <span style={{color: "white", marginLeft: 10}}> 
          Account Visibility.  
      </span>
      </label>
      {accountvisibility && (
        <div>
          <div>
          <label> 
          <input 
            checked={accountvisibility === "Private Account"}
            onChange={() => setaccountvisibility("Private Account")}
            type="checkbox" style={{marginLeft: 30}}/>
            <span style={{color: "white", marginLeft: 10}}> 
           Private Account
           </span>
         </label>
         <br />
         </div>
         <div>
         <label>
         <input 
          checked={accountvisibility === "Public Account"}
          onChange={() => setaccountvisibility("Public Account")}
          type="checkbox" style={{marginLeft: 30}}/> 
          <span style={{color: "white", marginLeft: 10}}> 
           Public Account
           </span>
         </label>
         <br />
         </div>
         </div>
      )}
      </div>
      <div>
      <label>
      <input 
        type="checkbox"
        checked={activityvisibility}
        onChange={() => setactivityvisibility(!activityvisibility)}
      />
      <span style={{color: "white", marginLeft: 10}}> 
          Activity Visibility.  
        </span> 
      </label>
      {activityvisibility && (
        <div>
          <div>
          <label> 
         <input 
          checked={activityvisibility === "Only friends"}
          onChange={() => setactivityvisibility("Only friends")}
          type="checkbox" style={{marginLeft: 30}}/>
          <span style={{color: "white", marginLeft: 10}}>  
           Only friends
           </span>
         </label>
         <br />
         </div>
         <div>
         <label> 
         <input 
          checked={activityvisibility === "Public Visibility"}
          onChange={() => setactivityvisibility("Public Visibility")}
          type="checkbox" style={{marginLeft: 30}}/>
          <span style={{color: "white", marginLeft: 10}}> 
           Public Visibility
           </span>
         </label>
         <br />
         </div>
         <div>
         <label> 
         <input 
          checked={activityvisibility === "Customize visibility"}
          onChange={() => setactivityvisibility("Customize visibility")}
         type="checkbox" style={{marginLeft: 30}}/>
         <span style={{color: "white", marginLeft: 10}}> 
           Customize visibility
           </span>
         </label>
         <br />
         </div>
         </div>
      )}
      </div>
      <div>
      <label>
      <input
        type="checkbox"
        checked={pastpostvisibility}
        onChange={() => setpastpostvisibility(!pastpostvisibility)}
      />
        <span style={{color: "white", marginLeft: 10}}> 
          Visibility of past posts.
        </span>   
      </label>
      {pastpostvisibility && (
        <div>
          <div>
          <label> 
         <input 
          checked={pastpostvisibility === "Only friends"}
          onChange={() => setpastpostvisibility("Only friends")}
          type="checkbox" style={{marginLeft: 30}}/>
          <span style={{color: "white", marginLeft: 10}}> 
           Only friends
           </span>
         </label>
         <br />
         </div>
         <div>
         <label> 
         <input 
          checked={pastpostvisibility === "Public Visibility"}
          onChange={() => setpastpostvisibility("Public Visibility")}
          type="checkbox" style={{marginLeft: 30}}/>
          <span style={{color: "white", marginLeft: 10}}> 
           Public Visibility
          </span>
         </label>
         <br />
         </div>
         <div>
         <label> 
         <input 
          checked={pastpostvisibility === "Customize visibility"}
          onChange={() => setpastpostvisibility("Customize visibility")}
          type="checkbox" style={{marginLeft: 30}}/>
          <span style={{color: "white", marginLeft: 10}}> 
           Customize visibility
          </span>
         </label>
         <br />
         </div>
         </div>
      )}
      </div>
      <div>
      <label>
      <input 
        type="checkbox"
        checked={profilelinking}
        onChange={() => setprofilelinking(!profilelinking)}
      />
        <span style={{color: "white", marginLeft: 10}}> 
          Profile linking in comments and tags. 
        </span>   
      </label>
      {profilelinking && (
        <div>
          <label>
          <input 
          checked={profilelinking === "Enable"}
          onChange={() => setprofilelinking("Enable")}
          type="checkbox" style={{marginLeft: 30}}/> 
          <span style={{color: "white", marginLeft: 10}}> 
           Enable
          </span>
          <br />
         </label>
         <label> 
         <input
          checked={profilelinking === "Disable"}
          onChange={() => setprofilelinking("Disable")} 
          type="checkbox" style={{marginLeft: 30}}/>
          <span style={{color: "white", marginLeft: 10}}> 
           Disable
          </span>
         </label>
         <br />
         </div>
      )}
      </div>

      <h3 className= "st-text-label" style={{color: "white"}}>3. Data Download & account Deletion. </h3>
      <div>
      <label>
      <input 
        type="checkbox"
        checked={datadownload}
        onChange={() => setdatadownload(!datadownload)}
      />
      <span style={{color: "white", marginLeft: 10}}> 
          Download Media files.    
      </span>
      </label>
      {datadownload && (
        <div>
          <div>
          <label> 
         <input 
          checked={datadownload === "Restricted to connections"}
          onChange={() => setdatadownload("Restricted to connections")}
          type="checkbox" style={{marginLeft: 30}}/>
          <span style={{color: "white", marginLeft: 10}}> 
           Restricted to connections
           </span>
         </label>
         <br />
         </div>
         <div>
         <label>
         <input 
          checked={datadownload === "Allow public download"}
          onChange={() => setdatadownload("Allow public download")}
         type="checkbox" style={{marginLeft: 30}}/> 
         <span style={{color: "white", marginLeft: 10}}> 
           Allow public download
          </span>
         </label>
         <br />
         </div>
         <div>
         <label> 
         <input 
          checked={datadownload === "Restrict download"}
          onChange={() => setdatadownload("Restrict download")}          
          type="checkbox" style={{marginLeft: 30 }}/>
          <span style={{color: "white", marginLeft: 10}}> 
           Restrict download
          </span>
         </label>
         <br />
         </div>
         </div>
      )}
      </div>
      <div>
      <label>
      <input 
        type="checkbox"
        checked={personaldatadownload}
        onChange={() => setpersonaldatadownload(!personaldatadownload)}      
      />
      <span style={{color: "white", marginLeft: 10}}> 
        Export personal data     
      </span>
      </label>
      {personaldatadownload && (
        <div>
          <div>
          <label> 
         <input 
          checked={personaldatadownload === "Restricted to connections"}
          onChange={() => setpersonaldatadownload("Restricted to connections")}
         type="checkbox" style={{marginLeft: 30}}/>
         <span style={{color: "white", marginLeft: 10}}> 
           Restricted to connections
         </span>
         </label>
         <br />
         </div>
         <div>
         <label> 
         <input 
          checked={personaldatadownload === "Allow public download"}
          onChange={() => setpersonaldatadownload("Allow public download")}
         type="checkbox" style={{marginLeft: 30 }}/>
         <span style={{color: "white", marginLeft: 10}}>  
           Allow public download
         </span>
         </label>
         <br />
         </div>
         <div>
         <label> 
         <input 
          checked={personaldatadownload === "Restrict download"}
          onChange={() => setpersonaldatadownload("Restrict download")}
         type="checkbox" style={{marginLeft: 30}}/>
         <span style={{color: "white", marginLeft: 10}}> 
           Restrict download
          </span>
         </label>
         <br />
         </div>
         </div>
      )}
      </div>
      <div>
      <label>
      <input
        type="checkbox"
        checked={deletionstrategy}
        onChange={() => setdeletionstrategy(!deletionstrategy)}      
      />
      <span style={{color: "white", marginLeft: 10}}> 
        Deletion strategy
      </span>
      </label>
      {deletionstrategy && (
        <div>
          <div>
          <label> 
         <input 
          checked={deletionstrategy === "Delete all data"}
          onChange={() => setdeletionstrategy("Delete all data")}
         type="checkbox" style={{marginLeft: 30}}/>
         <span style={{color: "white", marginLeft: 10}}> 
           Delete all data
         </span>
         </label>
         <br />
         </div>
         <div>
         <label> 
         <input 
          checked={deletionstrategy === "Archive data before deletion (for limited time)"}
          onChange={() => setdeletionstrategy("Archive data before deletion (for limited time)")}
         type="checkbox" style={{marginLeft: 30}}/>
         <span style={{color: "white", marginLeft: 10}}> 
           Archive data before deletion (for limited time)
         </span>
         </label>
         <br />
         </div>
         </div>
      )}
      </div>
      <div>
      <label>
      <input type="checkbox"
        checked={profiledeletionstrategy}
        onChange={() => setprofiledeletionstrategy(!profiledeletionstrategy)}      
      />
      <span style={{color: "white", marginLeft: 10}}> 
        Profile Deletion strategy  
      </span>   
      </label>
      {profiledeletionstrategy && (
        <div>
          <div>
          <label>
         <input 
          checked={profiledeletionstrategy === "Delete all data"}
          onChange={() => setprofiledeletionstrategy("Delete all data")}
         type="checkbox" style={{marginLeft: 30 }}/> 
         <span style={{color: "white", marginLeft: 10}}> 
           Delete all data
          </span>
         </label>
         <br />
         </div>
         <div>
         <label> 
         <input 
          checked={profiledeletionstrategy === "Archive data before deletion (for limited time)"}
          onChange={() => setprofiledeletionstrategy("Archive data before deletion (for limited time)")}
         type="checkbox" style={{marginLeft: 30}}/>
         <span style={{color: "white", marginLeft: 10}}> 
           Archive data before deletion (for limited time)
          </span>
         </label>
         <br />
         </div>
         </div>
      )}
      </div>

      <h3 className= "st-text-label" style={{color: "white"}}>4. Encrypted Messaging & Communication Privacy</h3>
      <div>
      <label>
      <input 
        type="checkbox"
        checked={encryptmessages}
        onChange={() => setencryptmessages(!encryptmessages)}            
      />
      <span style={{color: "white", marginLeft: 10}}> 
        Encrypt Direct Messaging.  
      </span>   
      </label>
      {encryptmessages && (
        <div>
          <label> 
         <input 
          checked={encryptmessages === "Enable"}
          onChange={() => setencryptmessages("Enable")}
         type="checkbox" style={{marginLeft: 30}}/>
         <span style={{color: "white", marginLeft: 10}}> 
           Enable
          </span>
         </label>
         <br />
         <label>
         <input 
          checked={encryptmessages === "Disable"}
          onChange={() => setencryptmessages("Disable")}
         type="checkbox" style={{marginLeft: 30}}/> 
         <span style={{color: "white", marginLeft: 10}}> 
           Disable
          </span>
         </label>
         <br />
         </div>
      )}      
      </div>
      <div>
      <label>
      <input
        type="checkbox"
        checked={encryptchathistory}
        onChange={() => setencryptchathistory(!encryptchathistory)}
      />
      <span style={{color: "white", marginLeft: 10}}> 
        Encryption of Chat History.
      </span>      
      </label>
      {encryptchathistory && (
        <div>
          <label>
         <input 
            checked={encryptchathistory === "Enable"}
            onChange={() => setencryptchathistory("Enable")}
            type="checkbox" style={{marginLeft: 30}}/> 
            <span style={{color: "white", marginLeft: 10}}> 
           Enable
           </span>
         </label>
         <br />
         <label> 
         <input 
          checked={encryptchathistory === "Disable"}
          onChange={() => setencryptchathistory("Disable")}
         type="checkbox" style={{marginLeft: 30}}/>
         <span style={{color: "white", marginLeft: 10}}> 
           Disable
          </span>
         </label>
         <br />
         </div>
      )}      
      </div>
      <div>
      <label>
      <input
        type="checkbox"
        checked={autodeletemessage}
        onChange={() => setautodeletemessage(!autodeletemessage)}
      />
      <span style={{color: "white", marginLeft: 10}}> 
        Auto-delete messages after a set time  
        </span>  
      </label>
      {autodeletemessage && (
        <div>
          <label>
          <input 
          checked={autodeletemessage === "Enable"}
          onChange={() => setautodeletemessage("Enable")}
          type="checkbox" style={{marginLeft: 30}}/> 
          <span style={{color: "white", marginLeft: 10}}> 
           Enable
           </span>
         </label>
         <br />
         <label>
         <input 
          checked={autodeletemessage === "Disable"}
          onChange={() => setautodeletemessage("Disable")}
          type="checkbox" style={{marginLeft: 30}}/> 
          <span style={{color: "white", marginLeft: 10}}> 
           Disable
           </span>
         </label>
         <br />
         </div>
      )}
      </div>

      <h3 className= "st-text-label" style={{color: "white"}}>5. Recommendation Strategy</h3>
      <div>
      <label>
      <input 
        type="checkbox" 
        checked={allowfeedtollmmodel}
        onChange={() => setallowfeedtollmmodel(!allowfeedtollmmodel)}      
      />
      <span style={{color: "white", marginLeft: 10}}> 
        Allow Personal data to feed to LLM model. 
        </span>      
      </label>
      {allowfeedtollmmodel && (
        <div>
          <label>
         <input 
          checked={allowfeedtollmmodel === "Enable"}
          onChange={() => setallowfeedtollmmodel("Enable")}
         type="checkbox" style={{marginLeft: 30}}/> 
         <span style={{color: "white", marginLeft: 10}}> 
           Enable
           </span>
         </label>
         <br />
         <label> 
         <input 
          checked={allowfeedtollmmodel === "Disable"}
          onChange={() => setallowfeedtollmmodel("Disable")}
          type="checkbox" style={{marginLeft: 30}}/>
          <span style={{color: "white", marginLeft: 10}}> 
           Disable
           </span>
         </label>
         <br />
         </div>
      )}
      </div>
      </div>
      )}

      {/* Terms & Conditions Checkbox */}
      <div className= "st-text-label" style={{marginTop: 30}}>
      <input type="checkbox" id="terms" checked={acceptedTerms} onChange={() => setAcceptedTerms(!acceptedTerms)}/>
        <label>
          <p style={{color: "white", marginLeft: 10, marginTop: 10}}>
          I accept the privacy settings. Kindly review. 
          </p>
        </label>
      </div>

      <button onClick={handleSubmit} className="st-submit">
            Submit
      </button>
      
      <div className= "st-text-label">
        <p className="cmn-copyright" style={{justifySelf: "center"}}>
          Oowlet copyright To Initiumnet Technology Pvt Ltd.. 
          More information about privacy policies and cookies, click <Link to="/" style={{ color: "blue", marginLeft: "5px" }}>here</Link>.
        </p>
      </div>   
    </div>
)}

export default SecuritySelector;